const dataIntegrationName = Object.freeze({
  DataImport: "Data Import",
  DataImportFromSO99Plus: "Data Import From SO99 Plus",
  ProjectsDataRefresh: "Projects Data Refresh",
  SearchDataRefresh: "Search Data Refresh",
  DataExport: "Data Export",
});

export default dataIntegrationName;
